export default {
  "pages.layouts.userLayout.title": "專案管理",
  "pages.login.pageTitle": "登入 / 註冊",
  "pages.login.success": "登入成功",
  "pages.login.failure": "登入失敗，請重試",
  "pages.login.email.placeholder": "電子郵件",
  "pages.login.email.required": "請輸入電子郵件",
  "pages.login.email.invalid": "請輸入有效的電子郵件地址",
  "pages.login.brandPitch": "專案 · 任務 · 進度，為團隊而生的一體化管理",
  "pages.login.heroTitle": "讓專案，看得見。\n讓延期，提前止損。",
  "pages.login.heroSubtitle":
    "甘特圖與 WBS 一屏掌握進度，延期、阻塞、臨近截止的風險提前預警，團隊全局一目了然。",
  "pages.login.slogan.1": "甘特圖，縱覽全局。",
  "pages.login.slogan.2": "WBS，逐層拆解任務。",
  "pages.login.slogan.3": "延期之前，提前預警。",
  "pages.login.slogan.4": "依賴與進度，一目了然。",
  "pages.login.line": "使用 LINE 繼續",
  "pages.login.google": "使用 Google 繼續",
  "pages.login.or": "或",
  "pages.login.socialComingSoon": "{provider} 登入即將開放",
  "pages.login.privacy":
    "繼續即表示同意我們的<terms>服務條款</terms>與<privacy>隱私政策</privacy>。",
  "pages.login.openMailbox.gmail": "開啟 Gmail ↗",
  "pages.login.openMailbox.yahooJp": "開啟 Yahoo!信箱 ↗",
  "pages.login.openMailbox.yahoo": "開啟 Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "開啟 iCloud 信箱 ↗",
  "pages.login.openMailbox.outlook": "開啟 Outlook ↗",
  "pages.login.code.send": "用電子郵件繼續",
  "pages.login.code.placeholder": "6 位驗證碼",
  "pages.login.code.required": "請輸入驗證碼",
  "pages.login.code.invalid": "請輸入 6 位數字",
  "pages.login.code.sent": "驗證碼已發送",
  "pages.login.code.sentTo": "請輸入發送到以下信箱的驗證碼：{email}",
  "pages.login.code.sendFailed": "驗證碼發送失敗",
  "pages.login.code.resendIn": "{seconds} 秒後可重新發送",
  "pages.login.code.resend": "重新發送驗證碼",
  "pages.login.continue": "繼續",
  "pages.login.changeEmail": "← 修改電子郵件",
  "pages.login.method.email": "電子郵件",
  "pages.login.method.password": "帳號・密碼",
  "pages.login.username.placeholder": "使用者名稱或電子郵件",
  "pages.login.username.required": "請輸入使用者名稱或電子郵件",
  "pages.login.password.placeholder": "密碼",
  "pages.login.password.required": "請輸入密碼",
  "pages.login.password.submit": "登入",
  "pages.404.subTitle": "抱歉，您造訪的頁面不存在",
  "pages.404.buttonText": "返回首頁",
  "pages.502.title": "無法連線到伺服器",
  "pages.502.subTitle": "伺服器暫時沒有回應，請稍後重試。",
  "pages.502.buttonText": "重新載入",
  "pages.oauth.title": "登入處理中",
  "pages.oauth.processing": "登入處理中…",
  "pages.oauth.success": "登入成功",
  "pages.oauth.fetchUserFailed": "取得使用者資訊失敗",
  "pages.oauth.backToLogin": "返回登入",
  "pages.oauth.error.stateMismatch": "認證資訊無效，請重試。",
  "pages.oauth.error.googleFailed": "Google 認證失敗，請重試。",
  "pages.oauth.error.disabled": "帳號已停用。",
  "pages.oauth.error.closing": "此帳號正在登出流程中，恢復請聯絡支援。",
  "pages.oauth.error.generic": "登入失敗，請稍後再試。",

  // 通用
  "common.action": "操作",
  "common.edit": "編輯",
  "common.delete": "刪除",
  "common.cancel": "取消",
  "common.confirm": "確認",
  "common.save": "儲存",
  "common.created": "建立成功",
  "common.updated": "更新成功",
  "common.deleted": "刪除成功",
  "common.createdAt": "建立時間",
  "common.reset": "重設",
  "common.export": "匯出",
  "common.exporting": "匯出中...",
  "common.export.success": "匯出成功",
  "common.export.noData": "沒有可匯出的資料",
  "common.import": "批次匯入",
  "common.upload": "點擊上傳",

  // 設定
  "notifications.title": "通知訊息",
  "settings.tab.account": "帳號設定",
  "settings.tab.security": "安全設定",
  "settings.account.info": "帳號資訊",
  "settings.account.username": "帳號",
  "settings.account.tenant": "租戶 ID",
  "settings.account.userCode": "用戶編號",
  "settings.account.createdAt": "註冊時間",
  "settings.account.displayName": "顯示名稱",
  "settings.account.displayNamePlaceholder": "請輸入顯示名稱",
  "settings.account.displayNameHint": "設定後，將代替帳號顯示",
  "settings.account.save": "儲存",
  "settings.account.displayNameSuccess": "顯示名稱已更新",
  "settings.password.title": "修改密碼",
  "settings.password.setTitle": "設定密碼",
  "settings.password.setHint":
    "你的帳號透過電子郵件 / Google 登入，尚未設定密碼。設定後即可使用「電子郵件 + 密碼」登入。無需舊密碼，僅需電子郵件驗證碼。",
  "settings.password.setSubmit": "設定密碼",
  "settings.password.changeDesc":
    "使用電子郵件驗證碼即可變更為新密碼，無需填寫目前密碼。",
  "settings.password.setSuccess":
    "密碼設定成功，現在可以使用電子郵件 + 密碼登入",
  "settings.password.old": "目前密碼",
  "settings.password.new": "新密碼",
  "settings.password.confirm": "確認新密碼",
  "settings.password.minLength": "密碼長度不能少於 6 位",
  "settings.password.mismatch": "兩次輸入的密碼不一致",
  "settings.password.submit": "修改密碼",
  "settings.password.success": "密碼修改成功",
  "settings.password.code": "驗證碼",
  "settings.password.codePlaceholder": "6 位數驗證碼",
  "settings.password.sendCode": "發送驗證碼",
  "settings.password.codeResendIn": "{seconds} 秒後重新發送",
  "settings.password.codeSent": "驗證碼已發送",
  "settings.password.codeSentTo": "驗證碼將發送至 {email}",
  "settings.password.codeInvalid": "請輸入 6 位數字",
  "settings.tab.app": "App設定",
  "settings.app.title": "App客製",
  "settings.app.icon": "App圖示",
  "settings.app.icon.desc":
    "上傳自訂圖示，用於行動應用顯示。建議使用 1024×1024 像素的 PNG 圖片。",
  "settings.app.icon.upload": "上傳圖示",
  "settings.app.icon.change": "更換圖示",
  "settings.app.icon.delete": "刪除圖示",
  "settings.app.icon.deleteConfirm": "確定刪除目前的圖示嗎？",
  "settings.app.icon.requirement": "PNG 格式，正方形，建議 1024×1024 px",
  "settings.app.icon.success": "圖示更新成功",
  "settings.app.icon.deleteSuccess": "圖示已刪除",
  "settings.app.icon.sizeError": "圖片尺寸需為正方形且不小於 512×512 像素",

  // --- 登出 ---
  "settings.account.logout": "登出",
  "settings.account.logoutDesc": "登出目前帳號，下次需重新登入。",
  "settings.account.logoutConfirmTitle": "確認登出？",

  // --- 註銷帳號 ---
  "settings.account.dangerZone": "危險操作",
  "settings.account.deleteAccount": "註銷帳號",
  "settings.account.deleteAccountDesc":
    "註銷後，帳號將在30天後被永久刪除。在此期間，您可以隨時透過登入恢復帳號。",
  "settings.account.deleteConfirmTitle": "確認註銷帳號？",
  "settings.account.deleteConfirmDesc":
    "請輸入密碼以確認註銷。註銷後您將被登出，30天內可透過登入恢復帳號。",
  "settings.account.deleteConfirmPassword": "請輸入密碼",
  "settings.account.deleteConfirmEmailDesc":
    "請輸入帳號信箱 {email} 以確認註銷。註銷後您將被登出，30天內可透過登入恢復帳號。",
  "settings.account.deleteConfirmEmailRequired": "請輸入帳號信箱",
  "settings.account.deleteConfirmEmailMismatch": "信箱與帳號不一致",
  "settings.account.deleteDataNotice": "30天後以下資料將被永久清空且無法恢復",
  "settings.account.deleteDataItem.records": "出入庫記錄",
  "settings.account.deleteDataItem.products": "產品資訊",
  "settings.account.deleteDataItem.user": "使用者資訊",
  "settings.account.deleteSuccess": "帳號註銷請求已送出",

  // 通知
  "notice.tab.system": "系統通知",
  "notice.tab.todo": "待辦提醒",
  "notice.empty": "尚無通知",
  "notice.todo.empty": "尚無待辦",
  "notice.readAll": "全部標為已讀",
  "notice.markSelectedRead": "標記已讀",
  "notice.selected": "已選 {count} 筆",
  "notice.viewAll": "查看全部",

  "notice.col.content": "訊息內容",
  "notice.col.time": "接收時間",
  "notice.col.type": "訊息類型",
  "notice.type.notice": "通知",
  "notice.type.announcement": "公告",
  "notice.detail.title": "訊息詳情",
  "notice.pagination.total": "共 {total} 筆",

  // 團隊邀請
  "invitation.inbox.title": "待處理邀請",
  "invitation.inbox.line": "{inviter} 邀請你加入「{team}」團隊",
  "invitation.inbox.expiresAt": "有效期至 {date}",
  "invitation.accept": "接受",
  "invitation.decline": "拒絕",
  "invitation.declineConfirm": "確定要拒絕此邀請嗎？",
  "invitation.acceptSuccess": "已加入「{team}」，可在右上角切換團隊",
  // 邀請郵件深連結接受頁
  "invitation.accept.pageTitle": "團隊邀請",
  "invitation.accept.loading": "正在確認邀請內容…",
  "invitation.accept.invalidTitle": "邀請連結無效",
  "invitation.accept.invalidDesc": "連結不正確或已失效，請請邀請人重新發送。",
  "invitation.accept.expiredTitle": "邀請已過期",
  "invitation.accept.expiredDesc": "此邀請已過期，請請邀請人重新發送。",
  "invitation.accept.acceptedTitle": "已接受",
  "invitation.accept.acceptedDesc": "此邀請已經被接受。",
  "invitation.accept.closedTitle": "此邀請已結束",
  "invitation.accept.declinedDesc": "此邀請已被拒絕。",
  "invitation.accept.revokedDesc": "此邀請已被撤銷。",
  "invitation.accept.loginToAccept": "登入並加入",
  "invitation.accept.later": "稍後再說",
  "invitation.accept.mismatchDesc":
    "此邀請寄往 {invited}，與目前帳號（{current}）不一致。請用被邀請的電子郵件登入。",
  "invitation.accept.switchAccount": "用其他帳號登入",
  "invitation.accept.goApp": "進入系統",

  // 設定 - 通知訊息

  // 設定 - 團隊管理
  "settings.tab.team": "團隊管理",
  "settings.tab.holidays": "節假日管理",
  "settings.tab.workday": "工時設定",
  "settings.tab.mcp": "MCP設定",
  // 工時設定標籤頁（1個工作日=多少小時）
  "pages.workday.title": "每日工時（工期換算）",
  "pages.workday.desc":
    "用於工期「天 ↔ 小時」的換算單位：1 個工作日 = 多少小時（預設 8h）。可依不同公司/專案以 8h、7.5h 等計算。",
  "pages.workday.label": "1 個工作日 =",
  "pages.workday.unit": "小時",
  "pages.workday.save": "儲存",
  "pages.workday.saved": "工時設定已儲存",
  "pages.workday.range": "請輸入 1〜24 之間的數值",
  "pages.workday.teamHint": "此設定會套用至整個工作區的工期顯示。",
  "pages.workday.ownerOnly": "此設定僅擁有者可變更。",
  "pages.workday.note":
    "不會變更既有任務已填的天數/小時數據，僅改變總工期與工數的「小時換算」解釋。",
  "settings.mcp.title": "AI 助手連接（MCP）",
  "settings.mcp.intro":
    "將此 URL 加入你的 ChatGPT / Claude 後，直接用聊天說話即可操作本 PM 系統（檢視、建立、更新任務等）。",
  "settings.mcp.urlLabel": "你的專屬連接 URL",
  "settings.mcp.warning":
    "此 URL 是你的個人金鑰，請勿分享給他人。若外洩，可點「重新產生 URL」使其失效。",
  "settings.mcp.regenerate": "重新產生 URL",
  "settings.mcp.regenerateConfirm": "重新產生後目前的 URL 會立即失效，確定嗎？",
  "settings.mcp.regenerated": "已產生新的 URL",
  "settings.mcp.setupTitle": "設定方法",
  "settings.mcp.claudeTitle": "在 Claude 中新增",
  "settings.mcp.chatgptTitle": "在 ChatGPT 中新增",
  "settings.mcp.cl1": "設定 → 連接器（不是「開發者 / 本地 MCP」）",
  "settings.mcp.cl2": "「新增自訂連接器」→ 貼上上面的 URL",
  "settings.mcp.cl3": "在對話裡啟用「PM 助手」後開始說話",
  "settings.mcp.cg1": "設定 → 連接器 → 進階設定 開啟「開發者模式」",
  "settings.mcp.cg2": "「新增自訂連接器」→ 貼上上面的 URL（認證：無）",
  "settings.mcp.cg3": "在對話裡選擇「PM 助手」後開始說話",
  "settings.mcp.example":
    "例如：「告訴我〇〇專案裡延期的任務」「把這段需求拆成任務並登記」",
  "team.name.title": "工作區名稱",
  "team.name.desc":
    "工作區名稱即你的租戶名，會顯示在團隊切換器等位置，僅主帳號可修改。",
  "team.name.edit": "修改",
  "team.name.placeholder": "請輸入工作區名稱",
  "team.name.required": "工作區名稱不能為空",
  "team.name.success": "工作區名稱已更新",
  "team.group.title": "團隊",
  "team.group.desc":
    "在工作區下建立多個團隊，邀請成員時可指定加入哪個團隊（PRO 方案）。成員只能看到所屬團隊的專案。",
  "team.group.create": "新增團隊",
  "team.group.editTitle": "編輯團隊",
  "team.group.col.name": "團隊名稱",
  "team.group.col.members": "成員數",
  "team.group.default": "預設",
  "team.group.members": "成員",
  "team.group.membersTitle": "「{name}」的成員",
  "team.group.membersDesc": "勾選加入該團隊的成員；成員可同屬多個團隊。",
  "team.group.membersPlaceholder": "選擇成員",
  "team.group.deleteConfirm":
    "確定刪除團隊「{name}」嗎？（需先遷移或刪除其下專案）",
  "team.group.nameRequired": "請輸入團隊名稱",
  "team.invite.teams": "加入團隊",
  "team.invite.teams.tip": "受邀者接受後自動加入所選團隊（可多選）。",
  "team.invite.teamsRequired": "請至少選擇一個團隊",
  "team.invite.teamsPlaceholder": "選擇團隊",
  "team.title": "團隊成員",
  "team.invite": "邀請成員",
  "team.invite.title": "邀請新成員",
  "team.invite.email": "電子郵件",
  "team.invite.emailInvalid": "請輸入正確的電子郵件",
  "team.invite.displayName": "顯示名（選填）",
  "team.invite.displayName.tip": "對方接受邀請後預設使用此名稱",
  "team.invite.message": "留言（選填）",
  "team.invite.checking": "正在檢查電子郵件…",
  "team.invite.alreadyMember": "該電子郵件已是本團隊成員",
  "team.invite.alreadyPending":
    "該電子郵件已有未處理的邀請，可點擊「重發」重新發送郵件",
  "team.invite.accountExists":
    "該電子郵件已註冊專案管理系統，對方接受後將作為成員加入",
  "team.invite.accountNew": "對方將透過該電子郵件註冊並加入團隊",
  "team.invite.success": "邀請已發送",
  "team.invite.resend": "重發",
  "team.invite.resendSuccess": "邀請已重發",
  "team.invite.revoke": "撤銷",
  "team.invite.revokeConfirm": "確定撤銷此邀請嗎？",
  "team.invite.col.email": "電子郵件",
  "team.invite.col.expiresAt": "過期時間",
  "team.invite.col.createdAt": "邀請時間",
  "team.invitations.title": "待處理邀請",
  "teamSwitcher.title": "切換團隊",
  "lang.ja-JP": "日語",
  "lang.en-US": "英語",
  "lang.zh-CN": "簡體中文",
  "lang.zh-TW": "繁體中文",
  "teamSwitcher.switched": "已切換到「{team}」",
  "team.col.displayName": "暱稱",
  "team.col.username": "帳號",
  "team.col.role": "角色",
  "team.col.teams": "所屬團隊",
  "team.allTeams": "全部團隊",
  "team.col.status": "狀態",
  "team.role.owner": "主帳號",
  "team.role.member": "成員",
  "team.status.active": "正常",
  "team.status.disabled": "已停用",
  "team.status.invited": "待邀請",
  "team.edit": "編輯",
  "team.edit.success": "成員資訊已更新",
  "team.remove": "移除",
  "team.remove.confirm": "確定移除該成員嗎？移除後該帳號將無法登入。",
  "team.disable": "停用",
  "team.enable": "啟用",
  "team.permissions": "權限設定",
  "team.permissions.title": "編輯權限 - {name}",
  "team.permissions.selectAll": "全選",
  "team.permissions.resetDefaults": "恢復預設",
  "team.permissions.resetDefaults.confirm": "確定恢復為預設權限嗎？",
  "team.permissions.save.success": "權限設定已儲存",
  "team.permissions.reset.success": "已恢復預設權限",
  "team.permissions.custom": "自訂",
  "team.permissions.default": "預設",
  "team.permissions.col.category": "分類",
  "team.permissions.col.target": "操作對象",
  "team.permissions.col.permissions": "功能權限",
  "team.permissions.group.product": "商品管理",
  "team.permissions.group.contact": "往來單位",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "收入",
  "team.permissions.group.analytics": "資料分析",
  "team.permissions.action.list": "查看",
  "team.permissions.action.add": "新增",
  "team.permissions.action.edit": "編輯",
  "team.permissions.action.delete": "刪除",
  "team.permissions.action.void": "作廢",
  "team.permissions.action.export": "匯出",
  "team.permissions.action.view": "查看",
  "team.permissions.action.category": "分類管理",

  // 首次登入修改密碼
  "changeInitialPassword.title": "修改初始密碼",
  "changeInitialPassword.hint": "為了帳號安全，建議修改初始密碼",
  "changeInitialPassword.new": "新密碼",
  "changeInitialPassword.confirm": "確認新密碼",
  "changeInitialPassword.submit": "確認修改",
  "changeInitialPassword.skip": "跳過，稍後修改",
  "changeInitialPassword.success": "密碼修改成功",

  // PM 俯瞰頁
  "overview.title": "俯瞰",
  "overview.subtitle": "跨專案的延遲・風險一目了然，第一時間發現問題",
  "overview.view.all": "全社俯瞰",
  "overview.view.member": "我的任務",
  "overview.notMember": "目前帳號尚未加入 PM 成員，無法檢視「我的任務」",
  "overview.kpi.activeProjects": "進行中專案",
  "overview.kpi.delayedProjects": "延遲專案",
  "overview.kpi.delayedTasks": "延遲任務",
  "overview.kpi.blocked": "阻塞中",
  "overview.kpi.dueSoon": "本週到期",
  "overview.kpi.unassigned": "未分配",
  "overview.stat.title": "任務概覽",
  "overview.stat.inProgress": "進行中的任務",
  "overview.stat.delayed": "延遲的任務",
  "overview.stat.delayed.tip": "點擊只看延遲的任務",
  "overview.stat.thisWeek": "本週的任務",
  "overview.risk.title": "風險一覽",
  "overview.risk.clearFilter": "清除篩選",
  "overview.risk.filter.delayed": "僅延遲任務",
  "overview.risk.empty": "沒有延遲・風險 🎉",
  "overview.risk.col.kind": "風險",
  "overview.risk.col.project": "客戶 / 專案",
  "overview.risk.col.task": "任務",
  "overview.risk.col.taskProject": "任務 / 客戶・專案",
  "overview.risk.col.assignee": "擔當",
  "overview.risk.col.due": "期日",
  "overview.risk.col.delay": "延遲",
  "overview.risk.col.progress": "進度",
  "overview.kind.overdue": "逾期",
  "overview.kind.behind": "進度落後",
  "overview.kind.blocked": "依賴阻塞",
  "overview.kind.due-soon": "臨近期日",
  "overview.kind.unassigned": "未分配",
  "overview.delay.overdueDays": "逾期 {n} 天",
  "overview.delay.dueInDays": "還剩 {n} 天",
  "overview.delay.today": "今日",
  "overview.unassignedLabel": "未分配",
  "overview.health.title": "專案健康",
  "overview.health.empty": "暫無專案",
  "overview.health.delayBadge": "延遲 {n}",
  "overview.assignee.title": "任務數依擔當者分佈",
  "overview.assignee.empty": "尚無已指派任務",
  "overview.assignee.unassigned": "未指派",
  "overview.assignee.tasksUnit": "{n} 件",
  "overview.milestone.title": "本週里程碑",
  "overview.milestone.empty": "近期無里程碑",
  "overview.milestone.overdue": "逾期 {n} 天",
  "overview.milestone.dueIn": "還剩 {n} 天",
  "overview.my.kpi.open": "負責中的任務",
  "overview.my.kpi.delayed": "延遲",
  "overview.my.kpi.thisWeek": "本週到期",
  "overview.my.kpi.bugs": "我的缺陷（未完成）",
  "overview.my.kpi.bugsHigh": "高 {n}",
  "overview.my.count": "未完成 {n} 件",
  "overview.my.countShort": "{n} 件",
  "overview.my.noDue": "無截止日",
  "overview.my.tasks.title": "我的任務",
  "overview.my.tasks.hint": "點擊列開啟甘特圖",
  "overview.my.tasks.empty": "沒有未完成的負責任務 🎉",
  "overview.my.bucket.overdue": "延遲",
  "overview.my.bucket.today": "今天",
  "overview.my.bucket.week": "本週",
  "overview.my.bucket.later": "下週及以後",
  "overview.my.more": "顯示剩餘 {n} 件",
  "overview.my.show": "顯示",
  "overview.my.collapse": "收合",
  "overview.my.bugs.title": "我的缺陷",
  "overview.my.bugs.viewAll": "查看全部",
  "overview.my.bugs.empty": "沒有未完成的負責缺陷",
  "overview.my.bugs.age": "{n} 天前",
  "overview.my.projects.title": "參與中的專案",
  "overview.my.milestones.title": "近期里程碑",

  // PM 日曆（個人 / 全員月視圖）
  "calendar.title": "日曆",
  "calendar.subtitle": "一眼看清今天/本週要做的任務",
  "calendar.view.all": "全員",
  "calendar.view.member": "我的",
  "calendar.notMember": "目前帳號未登記為 PM 成員，無法顯示「我的」",
  "calendar.empty": "無相關任務",
  "calendar.today": "今天",
  "calendar.filter.all": "全部",
  "calendar.filter.task": "僅任務",
  "calendar.filter.event": "僅事件",
  "calendar.fullscreen": "全螢幕",
  "calendar.fullscreenExit": "退出全螢幕",

  // 事件 / 會議日程（嵌入日曆）
  "event.legend": "事件類型",
  "event.type.meeting": "會議",
  "event.type.review": "評審",
  "event.type.milestone": "里程碑",
  "event.type.deadline": "截止",
  "event.type.other": "其他",
  "event.new": "新增事件",
  "event.edit": "編輯事件",
  "event.field.title": "標題",
  "event.field.type": "類型",
  "event.field.start": "開始",
  "event.field.end": "結束",
  "event.field.allDay": "全天",
  "event.field.project": "專案",
  "event.field.task": "關聯任務",
  "event.field.attendees": "參加人",
  "event.field.location": "地點",
  "event.field.note": "備註",
  "event.field.projectGlobal": "全域（不掛專案）",
  "event.save": "儲存",
  "event.cancel": "取消",
  "event.delete": "刪除",
  "event.deleteConfirm": "確認刪除該事件？",
  "event.saved": "已儲存",
  "event.deleted": "已刪除",
  "event.validate.title": "請輸入標題",
  "event.validate.time": "請選擇開始時間",
  "event.validate.endBeforeStart": "結束時間不能早於開始時間",

  // PM 專案管理
  "projects.title": "專案管理",
  "projects.subtitle": "依客戶 / 產品組織專案，追蹤每個專案的進度",
  "projects.create": "建立專案",
  "projects.count": "{count} 個專案",
  "projects.searchPlaceholder": "搜尋專案…",
  "projects.filter.all": "全部",
  "projects.filter.placeholder": "依名稱 / 說明篩選",
  "projects.filter.emptyKw": "此客戶底下沒有符合「{kw}」的專案",
  "projects.filter.bridge": "在任務 / Bug 中搜尋「{kw}」",
  "projects.status.all": "全部狀態",
  "projects.status.planned": "未開始",
  "projects.status.active": "進行中",
  "projects.status.paused": "已暫停",
  "projects.status.done": "已交付",
  "projects.selectCustomerFirst": "請先在左側選擇客戶 / 產品",
  "projects.noMatch": "沒有符合的專案",
  "projects.emptyHint": "此客戶尚未建立專案，點擊「建立專案」開始",
  "projects.card.edit": "編輯專案",
  "projects.card.delete": "刪除專案",
  "projects.card.noDesc": "暫無描述",
  "projects.card.enter": "進入",
  "projects.card.overdue": "已逾期",
  "projects.col.progress": "進度",
  "projects.col.actions": "操作",
  "projects.reordered": "排序已更新",
  "projects.drag.hint": "拖曳以排序",
  "projects.drag.disabled": "清除搜尋 / 篩選後方可拖曳排序",
  "projects.customers.title": "客戶 / 產品",
  "projects.customers.new": "新增客戶 / 產品",
  "projects.customers.searchPlaceholder": "搜尋客戶…",
  "projects.customers.empty": "沒有客戶",
  "projects.customers.count": "{count} 個專案",
  "projects.customers.avg": "進度 {avg}%",
  "projects.customers.collapse": "收合列表",
  "projects.customers.expand": "展開列表",
  "projects.delete.title": "刪除專案",
  "projects.delete.content":
    "確定刪除「{customer} {name}」？該專案下的所有任務與相依也會一併刪除，且無法復原。",
  "projects.delete.ok": "刪除",
  "projects.deleted": "專案已刪除",
  "projects.form.createTitle": "建立專案",
  "projects.form.editTitle": "編輯專案",
  "projects.form.create": "建立",
  "projects.form.save": "儲存",
  "projects.form.customer": "客戶 / 產品",
  "projects.form.customerRequired": "請選擇客戶",
  "projects.form.customerPlaceholder": "選擇客戶",
  "projects.form.name": "專案名稱",
  "projects.form.nameRequired": "請輸入專案名稱，如 v1.0.0",
  "projects.form.namePlaceholder": "v1.0.0",
  "projects.form.description": "描述",
  "projects.form.descriptionPlaceholder": "本期主要內容…",
  "projects.form.status": "狀態",
  "projects.form.statusRequired": "請選擇狀態",
  // ===== 種別（一般專案 / 維運保守） =====
  "projects.form.kind": "種別",
  "projects.form.kindRequired": "請選擇種別",
  "projects.form.kindTip":
    "維運保守的需求隨時追加、範圍一直在變，因此不看達成率而看件數",
  "projects.kind.project": "一般專案",
  "projects.kind.projectDesc": "範圍固定的專案，用進度率管理",
  "projects.kind.ops": "維運・保守",
  "projects.kind.opsDesc": "改修需求隨時進來的長期專案，用件數管理",
  "projects.form.endRequired": "請選擇結束日期",
  "projects.form.endOptional": "留空即為「持續中」",
  "projects.form.startPlaceholder": "開始日期",
  "projects.form.endPlaceholder": "結束日期",
  "projects.form.endOngoing": "持續中（未定）",
  "projects.card.ongoing": "持續中",
  "projects.ops.thisMonth": "本月完成 {done}/{total} 件",
  "projects.ops.open": "未完成 {count} 件",
  // ===== 月度工時額度（保守契約的「每月◯人日」） =====
  "projects.form.quota": "月度工時額度",
  "projects.form.quotaTip":
    "保守合約的「每月◯人日」。設定後列表會顯示本月的消耗狀況",
  "projects.form.quotaOptional": "留空即為不設額度（只顯示件數）",
  "projects.form.quotaUnit": "人日 / 月",
  "projects.form.quotaPlaceholder": "例：20",
  "projects.ops.quotaActual": "實績 {used} / {quota}",
  "projects.ops.quotaPlanned": "預定 {used} / {quota}",
  "projects.ops.quotaOver": "超額",
  "projects.ops.quotaTooltip": "本月 預定 {planned} · 實績 {actual} · 額度 {quota}",
  "projects.form.range": "起訖時間",
  "projects.form.rangeRequired": "請選擇起訖時間",
  "projects.updated": "專案已更新",
  "projects.created": "專案已建立",
  "projects.cancel": "取消",
  "projects.customer.created": "客戶已建立",
  "projects.customer.createTitle": "新增客戶 / 產品",
  "projects.customer.name": "名稱（客戶 / 產品）",
  "projects.customer.nameRequired": "請輸入名稱，如 東邦銀行",
  "projects.customer.namePlaceholder": "例：東邦銀行 / 訂貨系統",
  "projects.customer.shortName": "簡稱",
  "projects.customer.shortNamePlaceholder": "選填，例：東邦 / 受発注",
  "projects.customer.team": "所屬團隊",
  "projects.customer.teamRequired": "請選擇團隊",
  "projects.customer.teamPlaceholder": "選擇團隊",
  "projects.customer.create": "建立",
  // ===== 甘特頁 Tab =====
  "projects.gantt.tab.wbs": "WBS",
  "projects.gantt.tab.board": "看板",
  "projects.gantt.tab.roadmap": "導入計畫",
  "projects.gantt.tab.design": "設計板",
  // ===== 看板檢視 =====
  "projects.board.status.backlog": "待辦池",
  "projects.board.status.todo": "待開始",
  "projects.board.status.inProgress": "進行中",
  "projects.board.status.testing": "測試",
  "projects.board.status.done": "已完成",
  "projects.board.status.cancelled": "已取消",
  "projects.board.empty": "暫無可在看板顯示的任務",
  // ===== 右側面板：檢視切換 / 年度日程 =====
  "projects.view.list": "版本一覽",
  "projects.view.annual": "年度日程",
  "projects.annual.newVersion": "新增版本",
  "projects.annual.empty": "{year} 年沒有相關版本",
  "projects.annual.release": "發布",
  "projects.annual.today": "今天",
  // ===== 甘特頁：WBS 表頭 / 行操作 / 工具列 =====
  "projects.gantt.col.name": "任務名",
  "projects.gantt.col.start": "開始時間",
  "projects.gantt.col.duration": "工期",
  "projects.gantt.col.progress": "進度",
  "projects.gantt.col.people": "人員",
  "projects.gantt.row.addChild": "新增子任務",
  "projects.gantt.row.edit": "編輯",
  "projects.gantt.row.delete": "刪除",
  "projects.gantt.scale.day": "日",
  "projects.gantt.scale.week": "週",
  "projects.gantt.expandAll": "全部展開",
  "projects.gantt.collapseAll": "全部摺疊",
  "projects.gantt.expandAllShort": "展開",
  "projects.gantt.collapseAllShort": "摺疊",
  "projects.gantt.addTask": "新增任務",
  "projects.gantt.empty.desc": "還沒有任務，點擊「新增任務」開始排程",
  "projects.gantt.notFound": "專案不存在",
  "projects.gantt.deleteTask.title": "刪除「{name}」？",
  "projects.gantt.deleteTask.summary":
    "該任務下的所有子任務及相關相依將一併刪除。",
  "projects.gantt.deleteTask.leaf": "相關相依連線將一併刪除。",
  // ===== 路線圖視圖 =====
  // dayjs 月份格式（时间轴表头）
  "projects.roadmap.monthFormat": "M月",
  "projects.roadmap.empty": "暫無可在路線圖展示的項目",
  "projects.roadmap.lane.milestone": "里程碑",
  "projects.roadmap.lane.system": "系統",
  "projects.roadmap.lane.business": "業務",
  "projects.roadmap.lane.default": "其他",
  "projects.roadmap.party.client": "貴司作業",
  "projects.roadmap.party.vendor": "我司作業",
  "projects.roadmap.legend.client": "貴司作業",
  "projects.roadmap.legend.vendor": "我司作業",
  "projects.roadmap.msColor.critical": "關鍵（紅）",
  "projects.roadmap.msColor.normal": "普通（灰）",
  "projects.roadmap.msColor.client": "貴司（綠）",
  "projects.roadmap.msColor.vendor": "我司（藍）",
  "projects.roadmap.optionManager.entry": "泳道管理",
  "projects.roadmap.optionManager.title": "泳道 / 里程碑色 管理",
  "projects.roadmap.optionManager.teamHint": "修改將套用至整個團隊",
  "projects.roadmap.optionManager.laneSection": "泳道",
  "projects.roadmap.optionManager.msColorSection": "里程碑色",
  "projects.roadmap.optionManager.addLane": "新增泳道",
  "projects.roadmap.optionManager.addMsColor": "新增顏色",
  "projects.roadmap.optionManager.namePlaceholder": "輸入名稱",
  "projects.roadmap.optionManager.system": "內建",
  "projects.roadmap.optionManager.deleteConfirm": "確定刪除？",
  "projects.roadmap.optionManager.nameRequired": "請輸入名稱",
  // ===== 任務編輯：基本資訊 =====
  "projects.taskForm.title.add": "新增任務",
  "projects.taskForm.title.edit": "編輯任務",
  "projects.taskForm.title.child": "在「{name}」下新增子任務",
  "projects.taskForm.name": "任務名",
  "projects.taskForm.nameRequired": "請輸入任務名",
  "projects.taskForm.namePlaceholder": "如：詳細設計_S0390_畫面",
  "projects.taskForm.type": "類型",
  "projects.taskForm.type.task": "普通任務",
  "projects.taskForm.type.summary": "匯總（階段）",
  "projects.taskForm.type.milestone": "里程碑",
  "projects.taskForm.project": "所屬專案（階段）",
  "projects.taskForm.projectHint":
    "切換到其他專案會把該任務及其全部子任務一併移過去；跨專案的相依連線會被清除。",
  "projects.taskForm.projectPlaceholder": "選擇所屬專案",
  "projects.taskForm.parent": "上層任務（父階段）",
  "projects.taskForm.parentHint":
    "把任務掛到所選專案的某個彙總（階段）下；留空＝置於最上層。",
  "projects.taskForm.parentRoot": "最上層（不掛任何階段）",
  "projects.taskForm.derivedHint":
    "彙總（階段）的工期與進度由其子任務自動彙總得出，無法直接編輯。請編輯子任務。",
  "projects.taskForm.summaryRangeOptionalHint":
    "可留空：新增子任務後將自動彙總工期；留空時暫以所屬專案的週期佔位。",
  "projects.taskForm.milestoneDate": "計劃里程碑日",
  "projects.taskForm.planRange": "計劃起止時間",
  "projects.taskForm.rangeRequired": "請選擇計劃時間",
  "projects.taskForm.rangeOutOfProject":
    "計劃時間需在專案週期（{start} ~ {end}）範圍內",
  "projects.taskForm.actualRange":
    "實際起訖時間（未開始留空・僅填開始＝進行中）",
  "projects.taskForm.actualStartRequired": "填寫結束日期時必須先填開始日期",
  "projects.taskForm.actualEndBeforeStart": "實際結束日期不能早於開始日期",
  "projects.taskForm.effort": "工期（天＋時）",
  "projects.taskForm.effortPlan": "計劃工期（天＋時）",
  "projects.taskForm.effortActual": "實際工期（天＋時）",
  "projects.taskForm.effortTip":
    "工期可直接手填 天d＋時h（0〜23.75，可小數 0.25 步進）；留空則依期間（工作日 × 每日工時）自動算。可點下方[使用]套用建議值",
  "projects.taskForm.effortSuffix": "小時",
  "projects.taskForm.effortDaysSuffix": "天",
  "projects.taskForm.effortUse": "使用",
  "projects.taskForm.effortHint":
    "{days}d（{days}個工作日 ≈ {hours}h｜1天 {hpd}h）",
  "projects.taskForm.effortManualBadge": "手動設定",
  "projects.taskForm.effortAutoBadge": "依期間自動（{dur}）",
  "projects.taskForm.levels": "標籤（可多個，按 Enter 新增）",
  "projects.taskForm.levelsPlaceholder":
    "輸入標籤後按 Enter，如：重要 / 難 / 前端",
  "projects.taskForm.progress": "進度",
  "projects.taskForm.status": "狀態",
  "projects.taskForm.assignee": "指派成員",
  "projects.taskForm.assigneePlaceholder": "選擇成員",
  "projects.taskForm.description": "描述（可貼圖）",
  "projects.taskForm.descriptionPlaceholder":
    "輸入任務描述，可直接貼上 / 拖曳截圖…",
  // ===== 任務評論 =====
  "projects.comments.title": "評論",
  "projects.comments.empty": "還沒有評論",
  "projects.comments.placeholder": "輸入評論（⌘/Ctrl+Enter 發送）",
  "projects.comments.send": "發送",
  "projects.comments.emoji": "表情",
  "projects.comments.edited": "已編輯",
  "projects.comments.deleteConfirm": "確定刪除這則評論？",
  // ===== 任務編輯：關聯連結（設計稿 / Figma） =====
  // ===== 任務操作日誌（抽屜右欄「操作日誌」頁籤） =====
  "projects.activity.title": "操作日誌",
  "projects.activity.empty": "還沒有操作紀錄",
  "projects.activity.emptyHint": "編輯任務後會自動記錄",
  "projects.activity.noneInFilter": "沒有符合該條件的紀錄",
  "projects.activity.today": "今天",
  "projects.activity.none": "未設定",
  "projects.activity.ongoing": "未定",
  "projects.activity.autoEffort": "依期間自動",
  "projects.activity.showFull": "顯示全文",
  "projects.activity.collapse": "收合",
  "projects.activity.filter.all": "全部操作",
  "projects.activity.filter.progress": "狀態·進度",
  "projects.activity.filter.schedule": "日程·工期",
  "projects.activity.filter.people": "擔當者·標籤",
  "projects.activity.filter.other": "說明·其他",
  "projects.activity.action.created": "建立了此任務",
  "projects.activity.action.updated": "修改了 {count} 個欄位",
  "projects.activity.action.updatedOne": "修改了 {field}",
  "projects.activity.action.childAdded": "新增了子任務",
  "projects.activity.action.childRemoved": "刪除了子任務",
  "projects.activity.action.depAdded": "新增了相依關係",
  "projects.activity.action.depRemoved": "解除了相依關係",
  "projects.activity.field.name": "任務名稱",
  "projects.activity.field.type": "類型",
  "projects.activity.field.status": "狀態",
  "projects.activity.field.progress": "進度",
  "projects.activity.field.planRange": "計畫期間",
  "projects.activity.field.actualRange": "實際期間",
  "projects.activity.field.plannedEffort": "計畫工期",
  "projects.activity.field.actualEffort": "實際工期",
  "projects.activity.field.assignees": "擔當者",
  "projects.activity.field.levels": "標籤",
  "projects.activity.field.description": "說明",
  "projects.activity.field.parent": "上層任務",
  "projects.activity.field.project": "所屬專案",
  "projects.activity.field.roadmapVisible": "路線圖",
  "projects.activity.field.roadmapLane": "泳道",
  "projects.activity.field.ownerParty": "作業區分",
  "projects.activity.field.milestoneColor": "里程碑顏色",
  "projects.activity.field.subtask": "子任務",
  "projects.activity.field.predecessor": "前置任務",
  "projects.activity.field.successor": "後續任務",
  "projects.activity.value.shown": "顯示",
  "projects.activity.value.hidden": "隱藏",
  "projects.links.title": "設計",
  "projects.links.empty": "還沒有關聯設計稿",
  "projects.links.urlPlaceholder": "貼上 Figma 連結（或其他網址）",
  "projects.links.titlePlaceholder": "備註名稱（選填，例如「登入頁 v2」）",
  "projects.links.add": "新增",
  "projects.links.figmaHint":
    "Figma 需設為「知道連結的任何人都可檢視」才能內嵌預覽",
  "projects.links.open": "在新分頁開啟",
  "projects.links.deleteConfirm": "確定移除這個連結？",

  // ===== 任務編輯：路線圖設定 =====
  "projects.taskForm.roadmap.panel": "路線圖設定",
  "projects.taskForm.roadmap.visible": "在路線圖展示",
  "projects.taskForm.roadmap.lane": "泳道",
  "projects.taskForm.roadmap.lanePlaceholder": "選擇泳道",
  "projects.taskForm.roadmap.ownerParty": "作業歸屬",
  "projects.taskForm.roadmap.milestoneColor": "里程碑顏色",
  "projects.taskForm.roadmap.milestoneColorPlaceholder": "選擇顏色",

  // ===== 成員視圖（資源視圖） =====
  "resources.title": "成員視圖",
  "resources.subtitle": "依成員俯瞰跨專案的任務分配，偵測排程撞期 / 負載衝突",
  "resources.mode.single": "單人",
  "resources.mode.all": "全員",
  "resources.year.auto": "自動",
  "resources.range.start": "開始月份",
  "resources.range.end": "結束月份",
  "resources.hideCompleted": "隱藏已完成任務",
  "resources.scale.day": "日",
  "resources.scale.week": "週",
  "resources.member.placeholder": "選擇成員",
  "resources.member.empty": "暫無成員",
  "resources.selectMemberFirst": "請先選擇成員",
  "resources.empty": "該成員暫無任務",
  "resources.allEmpty": "暫無已指派的任務",
  "resources.loading": "載入中…",
  "resources.view.timeline": "時間軸",
  "resources.view.list": "列表",
  "resources.list.total": "共 {n} 筆",
  "resources.col.task": "任務",
  "resources.col.project": "專案",
  "resources.col.assignee": "擔當",
  "resources.col.plan": "計劃",
  "resources.col.actual": "實績",
  "resources.col.progress": "進度",
  "resources.conflict.badge": "撞期",
  "resources.conflict.tip": "有 {count} 個任務時間重疊（同時承擔多個專案）",
  "resources.conflict.legend": "撞期 / 負載衝突",
  "resources.noSchedule": "（未排程）",
  "resources.backToAll": "返回全員視圖",
  "resources.openDetail": "查看該成員詳情",
  "resources.editTask": "編輯任務",

  // ===== 工時實績彙總（個人模式） =====
  "resources.stats.title": "工時實績彙總",
  "resources.stats.note": "含已完成任務",
  "resources.stats.hpd": "1 工作日={hpd}h",
  "resources.stats.hint":
    "依擔當「參與」口徑彙總（多擔當任務對每人計入全額工期，跨人合計會重複）。工期以 1 工作日={hpd}h 換算。",
  "resources.stats.collapse": "收合",
  "resources.stats.expand": "展開",
  "resources.stats.empty": "該期間無擔當任務",
  "resources.stats.kpi.actual": "實績合計工期",
  "resources.stats.kpi.planned": "計劃合計工期",
  "resources.stats.kpi.tasks": "稼動任務數",
  "resources.stats.kpi.rate": "消化率",
  "resources.stats.kpi.unit": "項",
  "resources.stats.kpi.target": "對象 {n} 項",
  "resources.stats.kpi.done": "完成 {n}",
  "resources.stats.kpi.wip": "進行 {n}",
  "resources.stats.kpi.remain": "剩餘 {v}",
  "resources.stats.kpi.over": "超出 {v}",
  "resources.stats.kpi.noPlan": "無計劃",
  "resources.stats.kpi.noPlanShort": "無計劃",
  "resources.stats.kpi.rateHint": "實績 / 計劃",
  "resources.stats.export.btn": "匯出 Excel",
  "resources.stats.export.sheet1": "概要",
  "resources.stats.export.sheet2": "任務列表",
  "resources.stats.export.member": "成員",
  "resources.stats.export.period": "期間",
  "resources.stats.export.allPeriod": "全期間",
  "resources.stats.export.metric": "指標",
  "resources.stats.export.value": "值",
  "resources.stats.export.delta": "計劃差",
  "resources.stats.export.doneLabel": "完成任務數",
  "resources.stats.export.wipLabel": "進行中任務數",
  "resources.stats.export.col.name": "任務名稱",
  "resources.stats.export.col.customer": "客戶",
  "resources.stats.export.col.status": "狀態",
  "resources.stats.export.col.planStart": "計劃開始",
  "resources.stats.export.col.planEnd": "計劃結束",
  "resources.stats.export.col.actualStart": "實際開始",
  "resources.stats.export.col.actualEnd": "實際結束",
  "resources.stats.export.status.done": "完成",
  "resources.stats.export.status.ongoing": "進行中(僅開始)",
  "resources.stats.export.status.wip": "進行中",
  "resources.stats.export.status.todo": "未著手",

  // ===== PM 客戶 / 產品頁 =====
  "customers.title": "客戶 / 產品",
  "customers.subtitle": "管理客戶與產品，作為專案的歸屬對象",
  "customers.new": "新增客戶",
  "customers.create": "建立",
  "customers.search.placeholder": "搜尋名稱 / 簡稱…",
  "customers.count": "共 {count} 個客戶 / 產品",
  "customers.col.name": "名稱",
  "customers.col.shortName": "簡稱",
  "customers.col.projectCount": "專案數",
  "customers.col.createdAt": "建立日期",
  "customers.empty": "還沒有客戶，點選「新增客戶」加入",
  "customers.edit": "編輯客戶",
  "customers.delete.title": "刪除「{name}」？",
  "customers.delete.hasProjects":
    "此客戶底下還有 {count} 個專案，刪除後這些專案將失去所屬客戶。",
  "customers.delete.irreversible": "刪除後無法復原。",
  "customers.msg.saved": "已儲存",
  "customers.msg.created": "客戶已建立",
  "customers.form.name": "名稱（客戶 / 產品）",
  "customers.form.name.required": "請輸入名稱，如 東邦銀行",
  "customers.form.name.placeholder": "例：東邦銀行 / 訂貨系統",
  "customers.form.shortName": "簡稱",
  "customers.form.shortName.placeholder": "可選，例：東邦 / 受発注",
  "customers.col.status": "狀態",
  "customers.status.active": "有效",
  "customers.status.inactive": "無效",
  "customers.form.active": "狀態",
  "customers.form.active.tip": "設為無效後，該客戶將作為封存處理",

  // ===== PM 富文字編輯器 =====
  "pm.rte.uploading": "圖片上傳中…",
  "pm.rte.uploadFailed": "圖片上傳失敗",
  "pm.rte.bold": "粗體",
  "pm.rte.italic": "斜體",
  "pm.rte.underline": "底線",
  "pm.rte.strike": "刪除線",
  "pm.rte.bulletList": "無序清單",
  "pm.rte.orderedList": "有序清單",
  "pm.rte.alignLeft": "靠左對齊",
  "pm.rte.alignCenter": "置中",
  "pm.rte.alignRight": "靠右對齊",
  "pm.rte.insertImage": "插入圖片",
  "pm.rte.imgSmall": "圖片：小",
  "pm.rte.imgMedium": "圖片：中",
  "pm.rte.imgFull": "圖片：滿寬",
  "pm.rte.hint": "可直接貼上 / 拖曳圖片",
  "pm.rte.placeholder": "輸入任務描述，可貼上圖片…",

  // ===== PM 甘特圖 · 實際時間 =====
  "gantt.actual.ongoing": "實際 {start}~ 進行中（未完了）",
  "gantt.actual.range": "實際 {start}~{end}（{dur}）",
  "gantt.tip.planEffort": "計畫工期",
  "gantt.tip.actualEffort": "實際工期",
  "gantt.foot.total": "總工期",
  "gantt.foot.planned": "計畫",
  "gantt.foot.actual": "實際",
  "gantt.foot.note": "※ 依 1天 = {hpd}小時 換算",

  // ===== PM 思維導圖（Mind Map） =====
  "mindmap.title": "思維導圖",
  "mindmap.empty": "還沒有思維導圖，新建一個開始吧",
  "mindmap.noProject": "未關聯專案",
  "mindmap.updatedAt": "更新於 {time}",
  "mindmap.notFound": "思維導圖不存在或已刪除",
  "mindmap.act.new": "新建導圖",
  "mindmap.act.editInfo": "編輯資訊",
  "mindmap.act.delete": "刪除",
  "mindmap.act.back": "返回",
  "mindmap.act.addChild": "新增子節點 (Tab)",
  "mindmap.act.addSibling": "新增同級 (Enter)",
  "mindmap.act.nodeColor": "節點顏色",
  "mindmap.act.collapseAll": "全部摺疊",
  "mindmap.act.expandAll": "全部展開",
  "mindmap.act.zoomIn": "放大",
  "mindmap.act.zoomOut": "縮小",
  "mindmap.act.fit": "適應視窗",
  "mindmap.act.exportPng": "匯出 PNG",
  "mindmap.act.reload": "重新整理",
  "mindmap.field.name": "名稱",
  "mindmap.field.nameRequired": "請輸入名稱",
  "mindmap.field.namePlaceholder": "例：產品規劃腦圖",
  "mindmap.field.project": "關聯專案（可選）",
  "mindmap.field.projectPlaceholder": "選擇專案",
  "mindmap.msg.created": "已建立",
  "mindmap.msg.updated": "已更新",
  "mindmap.msg.deleted": "已刪除",
  "mindmap.msg.confirmDelete": "確定刪除「{name}」？",
  "mindmap.save.saved": "已儲存",
  "mindmap.save.dirty": "未儲存…",
  "mindmap.save.saving": "儲存中…",
  "mindmap.save.error": "儲存失敗",
  "mindmap.save.conflict": "已被他人更新",
  "mindmap.theme.classic": "經典藍",
  "mindmap.theme.dark": "暗色",
  "mindmap.theme.forest": "森林綠",
  "mindmap.theme.sunset": "落日橙",
  "mindmap.tip.rootUndeletable": "中心主題不可刪除",
  "mindmap.hint.keys":
    "Tab 子節點 · Enter 同級 · 雙擊改名 · Delete 刪除 · Ctrl/⌘+滾輪縮放",

  // 節假日（紅日子）管理
  "pages.holidays.title": "節假日 / 紅日子",
  "pages.holidays.teamHint":
    "節假日為租戶級，修改對整個團隊生效。工期與進度已自動排除週末與這些紅日子。",
  "pages.holidays.syncNow": "立即同步",
  "pages.holidays.syncSuccess":
    "同步完成：新增 {added}、更新 {updated}、移除 {removed}",
  "pages.holidays.add": "新增",
  "pages.holidays.import": "批次匯入",
  "pages.holidays.yearAll": "全部年份",
  "pages.holidays.col.date": "日期",
  "pages.holidays.col.name": "名稱",
  "pages.holidays.col.source": "來源",
  "pages.holidays.col.action": "操作",
  "pages.holidays.source.manual": "手動",
  "pages.holidays.source.synced": "同步",
  "pages.holidays.edit": "編輯",
  "pages.holidays.delete": "刪除",
  "pages.holidays.deleteConfirm": "確定刪除這個紅日子？",
  "pages.holidays.empty":
    "尚無節假日。點「立即同步」從 holidays-jp 取得，或手動新增。",
  "pages.holidays.saved": "已儲存",
  "pages.holidays.addTitle": "新增節假日",
  "pages.holidays.editTitle": "編輯節假日",
  "pages.holidays.form.date": "日期",
  "pages.holidays.form.dateRequired": "請選擇日期",
  "pages.holidays.form.name": "名稱",
  "pages.holidays.form.nameRequired": "請輸入名稱",
  "pages.holidays.form.namePlaceholder": "例：元旦",
  "pages.holidays.importTitle": "批次匯入節假日",
  "pages.holidays.importHint":
    "每行一筆：YYYY-MM-DD 名稱（逗號 / 定位字元 / 空格分隔）。已存在的日期會自動略過。",
  "pages.holidays.importEmpty": "沒有可匯入的有效列",
  "pages.holidays.importResult": "已匯入 {added} 筆",

  // ===== 品質管理（Quality）=====
  "quality.title": "質量管理",
  "quality.subtitle": "測試案例的管理·執行記錄與缺陷單管理",
  "quality.selectProject": "選擇專案",
  "quality.noProject": "沒有可顯示的專案",
  "quality.tab.cases": "測試案例",
  "quality.tab.bugs": "缺陷管理",
  "quality.suite.title": "測試套件",
  "quality.suite.all": "全部",
  "quality.suite.add": "新增套件",
  "quality.suite.edit": "編輯套件",
  "quality.suite.name": "套件名稱",
  "quality.suite.prefix": "編號前綴（如 STU）",
  "quality.suite.description": "說明",
  "quality.suite.deleteConfirm": "確定刪除該套件及其下案例嗎？",
  "quality.suite.empty": "暫無套件，請點擊「新增套件」建立。",
  "quality.category.normal": "正常",
  "quality.category.abnormal": "異常",
  "quality.category.boundary": "邊界值",
  "quality.result.pass": "OK",
  "quality.result.fail": "NG",
  "quality.result.na": "不適用",
  "quality.result.untested": "未執行",
  "quality.priority.high": "高",
  "quality.priority.medium": "中",
  "quality.priority.low": "低",
  "quality.severity.high": "高",
  "quality.severity.medium": "中",
  "quality.severity.low": "低",
  "quality.bugStatus.open": "待處理",
  "quality.bugStatus.inProgress": "處理中",
  "quality.bugStatus.resolved": "已修復",
  "quality.bugStatus.verifying": "驗證中",
  "quality.bugStatus.closed": "已關閉",
  "quality.bugStatus.wontfix": "不處理",
  "quality.case.no": "編號",
  "quality.case.title": "測試觀點",
  "quality.case.feature": "功能",
  "quality.case.category": "分類",
  "quality.case.priority": "優先度",
  "quality.case.result": "執行結果",
  "quality.case.assignee": "執行人",
  "quality.case.task": "任務",
  "quality.case.actions": "操作",
  "quality.case.add": "新增案例",
  "quality.case.edit": "編輯案例",
  "quality.case.deleteConfirm": "確定刪除該案例嗎？",
  "quality.case.precondition": "前提條件",
  "quality.case.steps": "測試步驟",
  "quality.case.testData": "測試資料",
  "quality.case.expected": "期望結果",
  "quality.case.remark": "備註",
  "quality.case.raiseBug": "提缺陷",
  "quality.case.batchResult": "批次記錄執行結果",
  "quality.case.selectedN": "已選 {n} 項",
  "quality.case.searchPlaceholder": "依觀點·功能·編號搜尋",
  "quality.case.filterResult": "執行結果",
  "quality.case.filterCategory": "分類",
  "quality.case.filterPriority": "優先度",
  "quality.case.filterAssignee": "執行人",
  "quality.case.filterFeature": "功能",
  "quality.case.empty": "暫無案例",
  "quality.case.linkTask": "關聯任務",
  "quality.suite.linkTask": "關聯任務（可選）",
  "quality.case.unlinkTask": "解除關聯",
  "quality.case.notLinked": "未關聯",
  "quality.bug.no": "編號",
  "quality.bug.title": "標題",
  "quality.bug.severity": "影響度",
  "quality.bug.priority": "優先度",
  "quality.bug.status": "狀態",
  "quality.bug.assignee": "負責人",
  "quality.bug.reporter": "報告人",
  "quality.bug.task": "任務",
  "quality.bug.noTask": "無符合任務",
  "quality.bug.noDescription": "尚無說明。",
  "quality.bug.batchLinkN": "將選取{n}項關聯到任務",
  "quality.bug.batchLinkedN": "已關聯{n}項",
  "quality.bug.batchUnlink": "解除關聯",
  "quality.bug.batchUnlinkConfirm": "解除選取{n}項的任務關聯？",
  "quality.bug.linkExisting": "關聯既有缺陷",
  "quality.bug.linkExistingHint": "選擇要關聯到此任務的既有缺陷。",
  "quality.bug.selectBugs": "選擇缺陷",
  "quality.bug.project": "產品/項目",
  "quality.bug.wholeProduct": "（整個產品）",
  "quality.bug.selectProduct": "請選擇產品或項目",
  "quality.bug.movedTo": "已移動到「{product}」（重新編號）",
  "quality.bug.createdAt": "起票時間",
  "quality.bug.reportedOn": "起票日期",
  "quality.bug.resolvedAt": "完成日期",
  "quality.bug.testCase": "來源案例",
  "quality.bug.actions": "操作",
  "quality.bug.add": "提缺陷",
  "quality.bug.detail": "詳情",
  "quality.bug.edit": "編輯",
  "quality.bug.deleteConfirm": "確定刪除該缺陷單嗎？",
  "quality.bug.description": "內容（重現步驟/期望/實際）",
  "quality.bug.environment": "環境",
  "quality.bug.reopenCount": "重開 {n} 次",
  "quality.bug.filterStatus": "狀態",
  "quality.bug.filterSeverity": "影響度",
  "quality.bug.filterPriority": "優先度",
  "quality.bug.filterAssignee": "擔當者",
  "quality.bug.reportedFrom": "起票日 從",
  "quality.bug.reportedTo": "起票日 至",
  "quality.bug.resolvedFrom": "完成日 從",
  "quality.bug.resolvedTo": "完成日 至",
  "quality.bug.empty": "暫無缺陷單",
  "quality.bug.fromCase": "由案例 {caseNo} 提交",
  "quality.bug.tabCount": "未完成 {active} / 全部 {total}",
  "quality.bug.statusActive": "未完成",
  "quality.bug.overview.active": "未完成",
  "quality.bug.overview.highSeverity": "影響度·高",
  "quality.bug.overview.oldest": "最早的未完成",
  "quality.bug.overview.days": "天",
  "quality.bug.overview.thisWeek": "本週：提交 +{reported} ／ 完成 {resolved}",
  "quality.bug.searchPlaceholder": "依編號、標題、說明搜尋",
  "quality.bug.filterProject": "專案",
  "quality.bug.wholeProductShort": "整個產品",
  "quality.bug.advancedFilter": "更多篩選",
  "quality.bug.filterTask": "關聯任務",
  "quality.bug.taskLinked": "已關聯",
  "quality.bug.taskUnlinked": "未關聯",
  "quality.bug.clearFilters": "清除條件",
  "quality.bug.export": "匯出",
  "quality.bug.settings": "設定",
  "quality.bug.columns": "顯示欄位",
  "quality.bug.ageDays": "已 {n} 天",
  "quality.bug.more": "更多操作",
  "quality.bug.duplicate": "複製並提交",
  "quality.bug.copyLink": "複製連結",
  "quality.bug.linkCopied": "連結已複製",
  "quality.bug.selectedN": "已選 {n} 筆",
  "quality.bug.batchStatus": "修改狀態",
  "quality.bug.batchAssignee": "修改負責人",
  "quality.bug.batchLink": "關聯到任務",
  "quality.bug.batchDeleteConfirm": "確定刪除選取的 {n} 筆缺陷單嗎？",
  "quality.bug.clearSelection": "取消選取",
  "quality.bug.pageTotal": "共 {total} 筆，第 {start}–{end} 筆",
  "quality.bug.chip.reported": "提交日：{v}",
  "quality.bug.chip.resolved": "完成日：{v}",
  "quality.bug.chip.task": "關聯任務：{v}",
  "quality.bug.chip.reporter": "報告人：{v}",
  "quality.bug.chip.environment": "環境：{v}",
  "quality.bug.reopenCountHeader": "重開次數",
  "quality.bug.resolvedAtHint": "狀態改為「已修復」「已關閉」時自動記錄",
  "quality.common.undo": "復原",
  "quality.msg.undone": "已復原",
  "quality.common.save": "儲存",
  "quality.common.cancel": "取消",
  "quality.common.all": "全部",
  "quality.common.unassigned": "未分配",
  "quality.common.openGantt": "在甘特圖開啟",
  "quality.common.delete": "刪除",
  "quality.common.add": "新增",
  "quality.common.close": "關閉",
  "quality.common.actions": "操作",
  "quality.env.manage": "環境主資料",
  "quality.env.select": "選擇環境",
  "quality.env.empty": "尚未登記環境",
  "quality.env.emptyForProduct": "該產品尚未登記環境",
  "quality.env.name": "區分",
  "quality.env.browser": "終端/瀏覽器",
  "quality.env.url": "URL",
  "quality.env.namePlaceholder": "dev / stg / prod",
  "quality.env.browserPlaceholder": "Chrome / iOS Safari",
  "quality.env.urlPlaceholder": "https://dev.example.jp",
  "quality.env.deleteConfirm": "確定刪除該環境？",
  "quality.msg.saved": "已儲存",
  "quality.msg.deleted": "已刪除",
  "quality.msg.resultUpdated": "執行結果已更新",
  "quality.msg.batchDone": "已更新 {n} 項",
  "quality.msg.bugRaised": "已提交缺陷單 {bugNo}",
  "quality.msg.statusUpdated": "狀態已更新",
  "quality.msg.selectCases": "請先選擇案例",
  "quality.summary.execution": "消化率",
  "quality.task.openInQuality": "在質量管理中開啟",

  // 任務跨案件檢索（命令面板 ⌘K）
  "search.entry": "搜尋",
  "search.placeholder": "搜尋任務 / 案件 / 缺陷",
  "search.hint": "可依任務名、案件名、客戶名、缺陷編號搜尋",
  "search.empty": "沒有符合「{kw}」的結果",
  "search.kind.all": "全部",
  "search.kind.task": "任務",
  "search.kind.project": "案件",
  "search.kind.bug": "缺陷",
  "search.overdueDays": "逾期 {n} 天",
  "search.openTasks": "未完成 {n} 個",
  "search.foot.move": "移動",
  "search.foot.open": "開啟",
  "search.foot.openProject": "開啟案件",

  // WBS / 看板內的關鍵字篩選（跨案件搜尋走 ⌘K 面板）
  "projects.gantt.filter.placeholder": "依任務名篩選",
  "projects.gantt.filter.hits": "{n} 筆",
  "projects.gantt.filter.empty": "沒有符合「{kw}」的任務",
  "projects.gantt.filter.clear": "清除篩選",

  // 資料（外部ドライブのリンク：顧客 / 案件 / タスク）。設計 doc/design/pm-drive-docs.md
  "docs.title": "資料",
  "docs.projectButton": "專案資料 ({n})",
  "docs.add": "新增資料",
  "docs.linkToTask": "關聯資料",
  "docs.open": "在新分頁開啟",
  "docs.empty": "尚無登錄的資料",
  "docs.filterEmpty": "沒有符合條件的資料",
  "docs.unlinkedEmpty": "沒有未關聯任務的資料",
  "docs.taskEmpty": "此任務尚無關聯資料",
  "docs.selectToPreview": "選擇資料後在此預覽",
  "docs.deleteConfirm": "確定移除「{name}」的登錄嗎？",
  "docs.deleteConfirm.desc": "不會刪除雲端硬碟中的檔案，只移除 PM 中的登錄與任務關聯。",
  "docs.remove": "移除",
  "docs.unlinkConfirm": "確定取消與此任務的關聯嗎？",
  "docs.unlink": "取消關聯",
  "docs.linkTasks": "關聯任務",
  "docs.linkTasks.title": "關聯的任務",
  "docs.linkTasks.note": "將以所選任務取代現有關聯；清空則變為未關聯。",
  "docs.common": "客戶共通",
  "docs.projectWide": "整個專案",
  "docs.unlinked": "未關聯",
  "docs.addedBy": "新增者 {name}",
  "docs.group.project": "專案",
  "docs.provider.google": "Google 雲端硬碟",
  "docs.provider.microsoft": "SharePoint",
  "docs.provider.box": "Box",
  "docs.provider.other": "連結",
  "docs.kind.gdoc": "Google 文件",
  "docs.kind.gsheet": "Google 試算表",
  "docs.kind.gslide": "Google 簡報",
  "docs.kind.gfile": "檔案",
  "docs.kind.gfolder": "資料夾",
  "docs.kind.ms": "Microsoft 365 檔案",
  "docs.kind.box": "Box 檔案",
  "docs.kind.link": "外部連結",
  "docs.type.all": "全部類型",
  "docs.type.pdf": "PDF",
  "docs.type.xls": "試算表",
  "docs.type.doc": "文件",
  "docs.type.ppt": "簡報",
  "docs.type.img": "圖片",
  "docs.type.folder": "資料夾",
  "docs.type.file": "其他檔案",
  "docs.type.link": "連結",
  "docs.preview.hint": "無法顯示時，可能是沒有檢視權限、登入了其他帳號，或瀏覽器封鎖了內嵌內容。",
  "docs.fallback.title": "此資料無法預覽",
  "docs.fallback.google": "無法從 URL 讀取 Google 雲端硬碟的檔案 ID。改用檔案的共用連結重新登錄，或許即可預覽。",
  "docs.fallback.microsoft": "SharePoint / OneDrive 的資料目前僅支援連結，請在新分頁中開啟檢視。",
  "docs.fallback.box": "Box 的資料目前僅支援連結，請在新分頁中開啟檢視。",
  "docs.fallback.other": "這是外部網站的連結，請在新分頁中開啟檢視。",
  "docs.root.customer": "客戶根資料夾",
  "docs.root.project": "專案資料夾",
  "docs.root.unsetCustomer": "尚未設定客戶根資料夾",
  "docs.root.unsetProject": "尚未設定專案資料夾",
  "docs.root.unsetHint": "設定 Google 雲端硬碟資料夾後，可在此瀏覽其內容",
  "docs.root.set": "設定資料夾",
  "docs.root.change": "變更",
  "docs.root.remove": "取消設定",
  "docs.drawer.stats": "案件 {projects} 個・資料 {docs} 個",
  "docs.root.bannerHint": "檔案仍保存在客戶的雲端硬碟中。PM 只保存連結與關聯，檢視權限以雲端硬碟的共用設定為準。",
  "docs.root.openFolder": "開啟根資料夾",
  "docs.root.removeConfirm": "確定取消資料夾設定嗎？",
  "docs.view.registered": "已登錄資料 ({n})",
  "docs.view.unlinked": "未關聯 ({n})",
  "docs.folder.registerHint": "透過右上角「新增資料」登錄此資料夾中的檔案後，即可在此預覽並關聯任務",
  "docs.form.url.folder": "資料夾不能作為資料登錄。請設為根資料夾（案件資料夾），或登錄其中的檔案",
  "docs.search.placeholder": "依名稱、URL、任務名搜尋",
  "docs.col.name": "名稱",
  "docs.col.provider": "儲存位置",
  "docs.col.target": "關聯對象",
  "docs.col.createdAt": "新增日期",
  "docs.drawer.customer": "客戶資料",
  "docs.drawer.project": "專案資料",
  "docs.form.addTitle": "新增資料",
  "docs.form.rootTitle": "設定資料夾",
  "docs.form.mode.new": "透過 URL 登錄",
  "docs.form.mode.existing": "從已登錄中選擇",
  "docs.form.url": "共用連結（URL）",
  "docs.form.url.placeholder": "貼上 Google 雲端硬碟、SharePoint、Box 等的共用連結",
  "docs.form.url.rootPlaceholder": "貼上 Google 雲端硬碟資料夾的共用連結",
  "docs.form.url.extra": "檔案仍保存在雲端硬碟中，檢視權限依雲端硬碟的共用設定。",
  "docs.form.url.rootExtra": "如已設定資料夾，將被取代。",
  "docs.form.url.required": "請輸入 URL",
  "docs.form.url.invalid": "請輸入以 http:// 或 https:// 開頭的 URL（2000 字以內）",
  "docs.form.title": "顯示名稱",
  "docs.form.title.placeholder": "選填（留空則顯示檔名或網域）",
  "docs.form.scope": "關聯到",
  "docs.form.scope.task": "任務",
  "docs.form.project": "專案",
  "docs.form.project.required": "請選擇專案",
  "docs.form.tasks": "任務",
  "docs.form.tasks.placeholder": "選擇任務（可依 WBS 路徑搜尋）",
  "docs.form.tasks.required": "請至少選擇 1 個任務",
  "docs.form.existing": "資料",
  "docs.form.existing.placeholder": "選擇此專案中已登錄的資料",
  "docs.form.existing.required": "請至少選擇 1 份資料",
  "docs.hint.preview": "已識別為 {kind}（可預覽）",
  "docs.hint.linkOnly": "將作為 {provider} 連結登錄（無法預覽，在新分頁開啟）",
  "docs.msg.added": "已新增資料",
  "docs.msg.linked": "已關聯",
  "docs.msg.removed": "已移除",
  // Google Picker（第二步）。設計 doc/design/pm-drive-docs.md §7
  "docs.msg.addedN": "已新增 {n} 份資料",
  "docs.emptyWithFolder": "透過右上角「新增資料」從根資料夾中選擇檔案登錄。登錄後的資料可在此預覽並關聯任務",
  "docs.defaultName.folder.google": "Google 雲端硬碟資料夾",
  "docs.defaultName.folder.microsoft": "SharePoint 資料夾",
  "docs.defaultName.folder.box": "Box 資料夾",
  "docs.defaultName.folder.other": "共用資料夾",
  "docs.defaultName.gfile": "Google 雲端硬碟檔案",
  "docs.chip.all": "全部",
  "docs.chip.pdf": "PDF",
  "docs.chip.xls": "Excel",
  "docs.chip.doc": "Word",
  "docs.chip.ppt": "PowerPoint",
  "docs.chip.img": "圖片",
  "docs.chip.folder": "資料夾",
  "docs.form.mode.google": "從 Google 雲端硬碟選擇",
  "docs.form.mode.googleFolder": "從 Google 雲端硬碟選擇",
  "docs.picker.title": "選擇要登錄到 PM 的資料",
  "docs.picker.titleFolder": "選擇資料夾",
  "docs.picker.view.thisFolder": "此資料夾",
  "docs.picker.view.myDrive": "我的雲端硬碟",
  "docs.picker.view.sharedDrives": "共用雲端硬碟",
  "docs.picker.disabled": "尚未設定 Google 雲端硬碟整合",
  "docs.picker.disabled.desc": "管理員設定 Google Picker（API 金鑰與 OAuth 用戶端）後，即可直接從雲端硬碟選擇檔案。在此之前請使用「透過 URL 登錄」。",
  "docs.picker.pick": "從 Google 雲端硬碟選擇檔案",
  "docs.picker.pickMore": "繼續選擇",
  "docs.picker.pickFolder": "從 Google 雲端硬碟選擇資料夾",
  "docs.picker.repickFolder": "重新選擇資料夾",
  "docs.picker.removeItem": "移出選擇",
  "docs.picker.note": "選擇資料夾會一併新增其中的檔案。檔案仍保存在雲端硬碟，存取權限依雲端硬碟的共用設定。",
  "docs.picker.required": "請至少選擇 1 個檔案",
  "docs.picker.titleInFolder": "選擇「{name}」中的檔案",
  "docs.picker.expanded": "已從「{name}」新增 {n} 個檔案",
  "docs.picker.skipDup": "已略過 {n} 個已登錄的檔案",
  "docs.picker.importFiles": "同時將資料夾內的檔案登錄為資料",
  "docs.msg.rootImported": "已設定根資料夾並登錄 {n} 個檔案",
  "docs.picker.addN": "新增 {n} 個",
  "docs.picker.err.config": "無法取得 Google 雲端硬碟整合設定，請稍後再試。",
  "docs.picker.err.load": "無法載入 Google 指令碼。請檢查網路連線，以及封鎖廣告/追蹤的瀏覽器擴充功能。",
  "docs.picker.err.popup": "無法開啟 Google 登入視窗。請允許本站的彈出式視窗後再試一次。",
  "docs.picker.err.auth": "Google 授權失敗。請稍後再試或聯絡管理員。",
  "docs.picker.err.scope": "未授予雲端硬碟存取權限。請在同意畫面勾選 Google 雲端硬碟項目。",
};
